/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useCallback } from "react";

import {
  Typography,
  Grid
} from "@mui/material";
import { useReactToPrint } from 'react-to-print';
import msgNotificacion from '../../scripts/notification';
import LogoFS from '../../assets/images/logoFS.png';
import Formatter from "../../scripts/formatters";
import '../../styles/solicitudes.css';

const FormVacacionesPdf = ({ data, print, setPrint }) => {
  const componentRef = useRef(null);

  // useCallback para memorizar funciones y evitar re-renderizaciones innecesarias.
  const handleAfterPrint = useCallback(() => {
    msgNotificacion('Impresión exitosa', 'success', 500);
    setPrint(false);
  }, [setPrint]);

  const handleBeforeContent = useCallback(() => {
    msgNotificacion('Imprimiendo...', 'info', 1000);
  }, []);

  const handlePrint = useReactToPrint({
    documentTitle: 'FORMULARIO DE PERMISOS Y VACACIONES',
    content: () => componentRef.current,
    onAfterPrint: handleAfterPrint,
    onBeforeGetContent: handleBeforeContent,
  });

  // Utilice una función separada para la lógica de impresión real para mejorar la legibilidad
  const triggerPrint = useCallback(() => {
    if (componentRef.current) {
      setTimeout(() => {
        handlePrint()
      }, 500)
    }
  }, [handlePrint]);

  useEffect(() => {
    if (print) {
      triggerPrint()
    }
  }, [print, triggerPrint]);

  return (    
    <div style={{ padding: 1, margin: 1 }} className='no-print'>
      <div ref={componentRef} className='print-container'>
        {
          data?.map((row) => {
            return (
              <div key={row.IdSolicitud} className='vh-100 d-flex flex-column align-items-center'>
                <div className='d-flex align-items-center justify-content-center my-1 py-4'>
                  <img src={LogoFS} alt='Logo contrata' height={110} width={240} className='me-4' />

                  <h4 className='text-center fw-bolder'>
                    <span>FORMULARIO DE PERMISOS Y VACACIONES</span>
                    <p className='no-solicitud'>No. Solicitud: {row.IdSolicitud}</p>
                    <p className='no-accion'>No. Accion: {row.NoAccion}</p>
                  </h4>
                </div>

                <Grid container spacing={2} className='px-5 border py-4'>
                  {/* Fila #1 encabezado */}
                  <Grid item xs={2} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>CÓDIGO:</Typography>
                  </Grid>
                  <Grid item xs={2} md={5} className='pt-2'>
                    <Typography className='text-decoration-underline'>{row?.CodigoEmpleado}</Typography>
                  </Grid>
                  <Grid item xs={2} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>NOMBRE:</Typography>
                  </Grid>
                  <Grid item xs={6} md={3} className='pt-2'>
                    <Typography className='text-decoration-underline'>{row?.NombreEmpleado?.toUpperCase()}</Typography>
                  </Grid>
                  
                  {/* Fila #2 encabezado */}
                  <Grid item xs={3} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>TIPO DE SOLICITUD:</Typography>
                  </Grid>
                  <Grid item xs={3} md={5} className='pt-2'>
                    <Typography className='text-decoration-underline'>{row?.TipoSolicitud}</Typography>
                  </Grid>
                  <Grid item xs={3} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>SOLICITUD:</Typography>
                  </Grid>
                  <Grid item xs={3} md={3} className='pt-2'>
                    <Typography className='text-decoration-underline'>{row?.TipoVacacion}</Typography>
                  </Grid>

                  {/* Fila #3 encabezado */}
                  <Grid item xs={3} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>FECHA DE SOLICITUD:</Typography>
                  </Grid>
                  <Grid item xs={3} md={5} className='pt-2'>
                    <Typography className='text-decoration-underline'>{Formatter.dateFormatter(row?.FechaReg)}</Typography>
                  </Grid>
                  <Grid item xs={3} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>FECHA INICIO:</Typography>
                  </Grid>
                  <Grid item xs={3} md={3} className='pt-2'>
                    <Typography className='text-decoration-underline'>{Formatter.dateFormatter(row?.FechaInicio)}</Typography>
                  </Grid>
                  
                  {/* Fila #4 encabezado */}
                  <Grid item xs={3} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>CANT. DIAS:</Typography>
                  </Grid>
                  <Grid item xs={3} md={5} className='pt-2'>
                    <Typography>{row?.CantDias}</Typography>
                  </Grid>
                  <Grid item xs={3} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>FECHA FINAL:</Typography>
                  </Grid>
                  <Grid item xs={3} md={3} className='pt-2'>
                    <Typography className='text-decoration-underline'>{Formatter.dateFormatter(row?.FechaFinal)}</Typography>
                  </Grid>

                  {/* Fila #5 encabezado */}
                  <Grid item xs={2} md={2} className='pt-2'>
                    <Typography fontWeight='bold'>MOTIVO:</Typography>
                  </Grid>
                  <Grid item xs={10} md={10} className='pt-2'>
                    <Typography className='text-decoration-underline'>{row?.Motivo}</Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className='px-5 py-5 mt-1 border-bottom justify-content-between'>
                  <Grid item xs={3} md={3} textAlign='center'>
                    <Typography className='text-decoration-underline' fontSize={10}>{row?.NombreEmpleado}</Typography>
                    <Typography fontWeight='bolder'>Solicita</Typography>
                  </Grid>
                  <Grid item xs={3} md={3} textAlign='center'>
                    <Typography className='text-decoration-underline' fontSize={10}>{row?.JefeInmediato}</Typography>
                    <Typography fontWeight='bolder'>Autoriza</Typography>
                  </Grid>
                  <Grid item xs={3} md={3} textAlign='center'>
                    <Typography className='text-decoration-underline' fontSize={10}>{row?.JefeRRHH}</Typography>
                    <Typography fontWeight='bolder'>Recibe RRHH</Typography>
                  </Grid>
                </Grid> 
              </div>
            )
          })
        }
      </div>
    </div>
  )
}



export default FormVacacionesPdf;